<div  class="customHeaderLabel" (click)="onSortRequested($event)">  
    {{ headerText }}
    <span *ngIf="isRequired===true" style="color:#ea4040">*</span>
    <span> <i [ngClass]="iconClass"></i></span>
    <div *ngIf="params.enableMenu" #menuButton style="display:inline-block;"  class="customHeaderMenuButton"  (click)="onMenuClicked($event)"><i class="fa {{params.menuIcon}}"></i>
    </div>
</div>
<div class="row">
    <span class="customValidationText">
        {{validationText}}
    </span>
</div>

<div class="row">
    <span class="customValidationText">
        {{requiredForGMCS}}
    </span>
</div>

